import Crud from '../components/Admin/Crud'
import Add from '../components/Admin/Add'
import View from '../components/Admin/View'
import Edit from '../components/Admin/Edit'

let routes = {
    path: '/admin',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/admin',
            component: Crud,
            meta: {
              notification: false
            }
        },
        {
            path: '/admin/add',
            component: Add
        },
        {
            path: '/admin/view/:id',
            component: View
        },
        {
            path: '/admin/edit/:id',
            component: Edit
        }
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/admin.js